module.exports = __webpack_public_path__ + "img/image_cost.85af8c15.jpg";